
    <!--
 * 竖版-主标题
 * @LastEditTime: Mon Dec 23 2024 22:00:18 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_TH5620"  :class="[`normal`,`u_c_TH5620`]" ><h1 id="u_c_QC8921"  v-if="compData.mainTitleBg" :style="`background-image:url(${ compData.mainTitleBg })`" :class="[`normal`,`u_c_QC8921`]" ></h1><h1 id="u_c_YZMF22"  v-if="!compData.mainTitleBg" :class="[`normal`,`u_c_YZMF22`]" ><div id="u_c_VQWC23"  v-html="compData.emailPageTitle || langData.lineTitle" :style="`text-shadow:0 0 10px ${ pageData.titleShadowColor }`" :class="[`normal`,`u_c_VQWC23`]" ></div><div id="u_c_R92T24"  v-html="compData.emailPageTitle || langData.lineTitle" :style="`display:${ pageData.isEdit ? 'block' : 'inline' };background-image:linear-gradient(to bottom, ${ pageData.mainTitleColorUp },${ pageData.mainTitleColorUp }, ${ pageData.mainTitleColorDown },${ pageData.mainTitleColorDown })`" :class="[`normal`,`u_c_R92T24`]" ></div></h1></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"emailPageTitle":``,"mainTitleBg":``},"ja-JP":{"emailPageTitle":``,"mainTitleBg":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['ja-JP']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '主标题';

    // 自定义setup - 开始
    ;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_TH5620.normal{
position:relative;
display:flex;
justify-content:center;
width:10.00rem;

}
}.default{
.u_c_QC8921.normal{
position:absolute;
top:3.84rem;
width:2.75rem;
height:2.03rem;
margin:0;
left:3.32rem;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.default{
.u_c_YZMF22.normal{
position:absolute;
top:4.99rem;
width:9.47rem;
height:fit-content;
margin:0;
font-size:0.64rem;
text-align:center;
font-weight:bold;
line-height:1.1;

}
}.default{
.u_c_VQWC23.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.default{
.u_c_R92T24.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:cursor;
color:transparent;

}
}.ja-JP{
.u_c_TH5620.normal{
position:relative;
display:flex;
justify-content:center;
width:10.00rem;

}
}.ja-JP{
.u_c_QC8921.normal{
position:absolute;
top:3.84rem;
width:2.75rem;
height:2.03rem;
margin:0;
left:3.32rem;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.ja-JP{
.u_c_YZMF22.normal{
position:absolute;
top:4.99rem;
width:9.47rem;
height:fit-content;
margin:0;
font-size:0.64rem;
text-align:center;
font-weight:bold;
line-height:1.1;

}
}.ja-JP{
.u_c_VQWC23.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ja-JP{
.u_c_R92T24.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:cursor;
color:transparent;

}
}
</style>
